var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "detail" } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("ticimax.members"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("ticimax.segmentedMembersDesc"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "filters" }, [
      _c(
        "div",
        { staticClass: "members-search" },
        [
          _c("a-input-search", {
            attrs: { placeholder: _vm.$t("ticimax.searchAMember") },
            model: {
              value: _vm.filters.query,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "query", $$v)
              },
              expression: "filters.query",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "toolbox" },
      [
        _c("ve-pagination", {
          attrs: {
            total: _vm.totalMembers,
            "page-index": _vm.cursor.page,
            "page-size": _vm.cursor.perPage,
            "page-size-option": [10, 15, 20, 50, 100],
          },
          on: {
            "on-page-number-change": function (val) {
              return (_vm.cursor.page = val)
            },
            "on-page-size-change": function (val) {
              return (_vm.cursor.perPage = val)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.startSyncMembers } },
              [_vm._v("Sync Members")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "members-content",
        staticStyle: { display: "flex", gap: "10px" },
      },
      [
        _c(
          "div",
          { staticClass: "left" },
          [
            _vm._l(_vm.filters.groups, function (group, index) {
              return _c(
                "div",
                { key: group.id },
                [
                  _c("FilterGroup", {
                    attrs: {
                      "on-removed": _vm.onFilterGroupRemoved,
                      "show-remove-button": _vm.filters.groups.length > 1,
                    },
                    model: {
                      value: _vm.filters.groups[index],
                      callback: function ($$v) {
                        _vm.$set(_vm.filters.groups, index, $$v)
                      },
                      expression: "filters.groups[index]",
                    },
                  }),
                  _vm._v(" "),
                  _vm.filters.groups.length > 1 &&
                  index !== _vm.filters.groups.length - 1
                    ? _c("div", { staticClass: "filter-condition-wrapper" }, [
                        _c(
                          "div",
                          { staticClass: "filter-condition" },
                          [
                            _c(
                              "a-select",
                              {
                                class: { hovered: _vm.selectHovered },
                                attrs: { value: _vm.filters.operator },
                                on: {
                                  change: function (op) {
                                    return (_vm.filters.operator = op)
                                  },
                                  click: function (e) {
                                    e.stopPropagation()
                                  },
                                  mouseenter: function () {
                                    return (_vm.selectHovered = true)
                                  },
                                  mouseleave: function () {
                                    return (_vm.selectHovered = false)
                                  },
                                },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "or" } },
                                  [_vm._v(_vm._s(_vm.$t("chatbotv2.or")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "and" } },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("chatbotv2.and"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "filter-add-group-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "filter-add-group",
                  on: { click: _vm.addFilterGroup },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.addFilterGroup"))),
                  ]),
                ]
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c("ve-table", {
          staticStyle: { "word-break": "break-word" },
          style: {
            width: _vm.getMaxWidth() + "px",
          },
          attrs: {
            columns: _vm.getColumns(),
            "table-data": _vm.members,
            "row-style-option": _vm.rowStyleOption,
            "cell-style-option": _vm.cellStyleOption,
            "border-x": true,
            "border-y": true,
            "row-key-field-name": "_id",
            id: "ticimax-members-table",
            "fixed-header": true,
            "sort-option": _vm.sortOption,
            "scroll-width": _vm.getMaxWidth() + 3500,
            "clipboard-option": _vm.clipboardOption,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-add-group-plus" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }